<template>
  <div class="sr-upload">
    <template v-if="!getTextModel">
      <el-upload ref="SrUpload" :action="uploadFileUrl" :show-file-list="false" :http-request="
        (res) => {
          httpRequest(res, item);
        }
      " :on-success="
        (res, file, fileList) => {
          imgSuccessFn(item, res, file, fileList);
        }
      " :before-upload="
        (file) => {
          beforeUpload(item, file);
        }
      " :headers="{ Authorization: `${token_type} ${access_token}` }" :accept="item.fileType || ''" name="file"
        v-bind="item">
        <!-- 如果需要上传多张图片 -->
        <div class="upload_list_box" v-if="item.limit && value && Array.isArray(value)">
          <div class="el-upload-list--picture-card" v-for="(res, index) in value" :key="index">
            <template v-if="item.platform == 'video'">
              <video :src="res.url" autoplay="autoplay" muted controls :style="`width: ${item.width || 136}px; height: ${
                item.height || 136
              }px`" loop></video>
            </template>
            <template v-else>


              <img v-if="!noAuthentication" :src="`${previewUrl}?key=${res.id}&access_token=${access_token}`" :style="`width: ${item.width || 86}px; height: ${
                item.height || 86
              }px`" class="avatar" />
              <img v-else :src="res.url" :style="`width: ${item.width || 86}px; height: ${
                item.height || 86
              }px`" class="avatar" />

              <span @click.stop class="el-upload-list__item-actions">
                <span v-if="!noAuthentication" @click.stop="handlePreview(res.id)">
                  <!-- {{ value + "认证开启" }} {{ noAuthentication }} -->
                  <i class="icon-viewlarger"></i>
                </span>
                <span v-else @click.stop="handlePreview1(res.url)">
                  <!-- {{ value + "认证关闭" }} {{ noAuthentication }} -->
                  <i class="icon-viewlarger"></i>
                </span>
                <span v-if="!noAuthentication" @click.stop="handleRemove(res.id)">
                  <i class="icon-ashbin"></i>
                </span>
                <span v-else @click.stop="handleRemove1(res)">
                  <i class="icon-ashbin"></i>
                </span>
              </span>
            </template>
            <div v-if="item.isfileName" class="image-fileName" :style="`width: ${item.width || 136}px;`">{{res.fileName ? res.fileName.substring(0, res.fileName.lastIndexOf(".")):''}}
            </div>
            <div @click.stop="" v-if="item.isEditfileName">
              <el-input  v-model="res.fileName" :style="`width: ${item.width || 136}px;display:flex;z-index:999`"></el-input>
            </div>
            
          </div>
          <div v-if="value.length < item.limit" class="plus-box" :style="`width: ${item.width || 136}px; height: ${
            item.height || 136
          }px`">
            <i class="el-icon-plus avatar-uploader-icon"></i>
          </div>
          
        </div>
        <!-- 单图片上传 -->
        <div class="upload_file_box" :class="{ bigIcon: item.Img }" v-else>
          <div class="el-upload-list--picture-card" v-if="value && !Array.isArray(value)">
            <template v-if="item.platform == 'video'">
              <video :src="value.url" autoplay="autoplay" muted controls :style="`width: ${item.width || 136}px; height: ${
                item.height || 136
              }px`" loop></video>
            </template>
            <template v-else>
              <img v-if="!noAuthentication" :src="`${previewUrl}?key=${value.id}&access_token=${access_token}`" :style="`width: ${item.width || 86}px; height: ${
                item.height || 86
              }px`" class="avatar" />
              <img v-else :src="value.url" :style="`width: ${item.width || 86}px; height: ${
                item.height || 86
              }px`" class="avatar" />
              <span @click.stop class="el-upload-list__item-actions">
                <span v-if="!noAuthentication" @click.stop="handlePreview(value.id)">
                  <!-- {{ value + "认证开启" }} {{ noAuthentication }} -->
                  <i class="icon-viewlarger"></i>
                </span>
                <span v-else @click.stop="handlePreview1(value.url)">
                  <!-- {{ value + "认证关闭" }} {{ noAuthentication }} -->
                  <i class="icon-viewlarger"></i>
                </span>
                <span @click="handleUpload">
                  <i class="icon-zhongxinshangchuan"></i>
                </span>
                <span v-if="!noAuthentication" @click.stop="handleRemove(value.id)">
                  <i class="icon-ashbin"></i>
                </span>
                <span v-else @click.stop="handleRemove1(value)">
                  <i class="icon-ashbin"></i>
                </span>
              </span>
            </template>
            <div v-if="item.isfileName" class="image-fileName" :style="`width: ${item.width || 136}px;`"> {{value.fileName ? value.fileName.substring(0, value.fileName.lastIndexOf(".")) :
            ''}}</div>
             <div @click.stop="" v-if="item.isEditfileName">
              <el-input  v-model="value.fileName" :style="`width: ${item.width || 136}px;display:flex;`"></el-input>
            </div>
          </div>
          <div class="el-upload-list--picture-card" v-else-if="item.Img">
            <img :src="item.Img" :style="`width: ${item.width || 86}px; height: ${
              item.height || 86
            }px`" class="avatar" />
            <span @click.stop :style="`width: ${item.width || 86}px; height: ${
              item.height || 86
            }px`" class="el-upload-list__item-actions">
              <span @click="handleUpload">
                <i class="icon-upload"></i>
                <div>上传图片</div>
              </span>
            </span>
          </div>
          <div v-else class="plus-box" :style="`width: ${item.width || 136}px; height: ${
            item.height || 136
          }px`">
            <i class="el-icon-plus avatar-uploader-icon"></i>
          </div>
        </div>
      </el-upload>
    </template>
    <template v-else>
      <template v-if="item.fullUrl">
        <div class="viewImgOrVideo el-upload-list--picture-card" v-for="(res, index) in value" :key="index">
            <template v-if="item.platform == 'video'">
              <video :src="res.url" autoplay="autoplay" muted controls :style="`width: ${item.width || 136}px; height: ${
                item.height || 136
              }px`" loop></video>
            </template>
            <template v-else>
              <img  :src="res.url" :style="`width: ${item.width || 86}px; height: ${
                item.height || 86
              }px`" class="avatar" />
            </template>
          </div>
      </template>
      <template v-else>
        <uploadImgView :view-data="value" v-bind="item" />
      </template>
      
    </template>
    <el-dialog title="图片预览" :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt />
    </el-dialog>
  </div>
</template>

<script>
import uploadImgView from "../SrView/uploadImgView.vue";
export default {
  name: "SrUpload",
  components: {
    uploadImgView,
  },
  inject: ["uploadFileUrl", "previewUrl", "uploadRequest"],
  props: ["item", "value", "formComConfig", "noAuthentication", "form"],
  model: {
    prop: "value",
    event: "change",
  },
  computed: {
    access_token() {
      return sessionStorage.getItem("token");
    },
    token_type() {
      return sessionStorage.getItem("token_type");
    },
    // 是否采用文字模式
    getTextModel() {
      if (undefined === this.item.isText || "" === this.item.isText) {
        // item没有设置是否纯文本显示，判断全局的textModel
        return this.formComConfig.textModel;
      } else {
        return this.item.isText;
      }
    },
  },
  data() {
    return {
      dialogVisible: false,
      dialogImageUrl: "",
      imgType:
        "bmp,jpg,png,tif,gif,pcx,tga,exif,fpx,svg,psd,cdr,pcd,dxf,ufo,eps,ai,raw,WMF,webp,avif,apng",
      videoType: "avi,wmv,mpeg,mp4,m4v,mov,asf,flv,f4v,rmvb,rm,3gp,vob",
    };
  },
  methods: {
    // 图片上传
    httpRequest(obj, item) {
      let flag = "";
      flag = this.customBeforeUpload(item, obj.file);
      // console.log(flag, "上传校验");
      if (!flag) {
        return;
      }
      const formData = new FormData();
      formData.append("file", obj.file);
      this.uploadRequest.imgUpload(formData).then((res) => {
        if (this.item.limit && this.value && Array.isArray(this.value)) {
          // 多图片上传成功
          let fileList = this.value;
          fileList.push(res.data);
          this.$emit("change", fileList);
          this.$refs.SrUpload.clearFiles();
        } else {
          console.log(res.data);
          // 单图片上传成功
          this.$emit("change", res.data);
          this.$emit("imgChange", res.data);
        }
      });
    },
    /**
     * 图片上传
     * */
    handlePreview(id) {
      this.dialogImageUrl = `${this.previewUrl}?key=${id}&access_token=${this.access_token}`;
      this.dialogVisible = true;
    },
    handlePreview1(data) {
      this.dialogImageUrl = data;
      this.dialogVisible = true;
    },
    handleRemove(id) {
      if (this.item.limit && this.value && Array.isArray(this.value)) {
        let fileList = this.value.filter((res) => {
          return res.id != id;
        });
        this.$emit("change", fileList);
      } else {
        this.$emit("change", "");
        this.$emit("imgChange", "");
      }
    },
    handleRemove1(data) {
      if (this.item.limit && this.value && Array.isArray(this.value)) {
        let fileList = this.value.filter((res) => {
          return res != data;
        });
        this.$emit("change", fileList);
      } else {
        this.$emit("change", "");
        this.$emit("imgChange", "");
      }
    },
    handleUpload() {
      this.$refs.SrUpload.$children[0].$refs.input.click();
    },
    // 上传之前对文件进行校验
    beforeUpload(beforeUpload) { },
    // 自定义方法上传之前对文件进行校验
    customBeforeUpload(item, file) {
      let fileList = item.fileList || this.form[item.bind] || [];
      const limit = item.limit || 1;
      console.log("length", fileList.length, limit);
      if (fileList.length == limit && limit != 1) {
        this.$message({
          message: `上传文件不能超过${limit}个！`,
          type: "warning",
        });
        return false;
      }
      // //验证大小,格式
      //fileType是字符串
      item.fileType =
        item.fileType && item.fileType != "*"
          ? item.fileType
          : item.platform == "video"
            ? this.videoType
            : this.imgType;
      let maxFileSize = 200;
      item.fileSize = item.fileSize || maxFileSize;
      var testmsg = file.name
        .substring(file.name.lastIndexOf(".") + 1)
        .toLowerCase();
      let type = item.fileType.split(",");
      const fileSize = file.size / 1024 / 1024;
      const isLt2M = fileSize < item.fileSize;
      if (type.indexOf(testmsg) == -1) {
        this.$message({
          message: `上传文件只能是${item.fileType}格式!`,
          type: "warning",
        });
        return false;
      } else if (!isLt2M) {
        this.$message({
          message: `上传文件大小不能超过 ${item.fileSize}MB!`,
          type: "warning",
        });
        return false;
      }
      return true;
    },
    // 上传成功处理
    imgSuccessFn(item, res) {
      if (this.item.limit && this.value && Array.isArray(this.value)) {
        // 多图片上传成功
        let fileList = this.value;
        fileList.push(res.data);
        this.$emit("change", fileList);
        this.$refs.SrUpload.clearFiles();
      } else {
        console.log(res.data);
        // 单图片上传成功
        this.$emit("change", res.data);
        this.$emit("imgChange", res.data);
      }
    },
  },
};
</script>

<style lang="scss">
.image-fileName {
  overflow: hidden;
  word-break: break-all;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.viewImgOrVideo{
  padding-right: 12px;
}
</style>


// WEBPACK FOOTER //
// packages/SrUpload/SrUpload.vue